/* eslint-disable import/no-default-export */
import { StyledSubHeading } from 'components/headings'
import RegistryVisibilityForm from 'registry/forms/registry-visibility-form'

export default () => {
  return (
    <div>
      <StyledSubHeading>Visibility & Privacy</StyledSubHeading>
      <RegistryVisibilityForm
        onSubmitSuccess={() =>
          PubSub.publish(BLConstants.FLASH_MESSAGE, {
            variant: 'success',
            message: 'Your visibility & privacy settings have been updated!',
          })
        }
      />
    </div>
  )
}
